import { useQuery } from '@tanstack/react-query';
import type { ApiSistema } from '@/features/sistema/types';
import { newRequest } from '@/std/api/newRequest';
import { URL_ATUAL } from '@/std/url';

function apiSistemaPost(): Promise<ApiSistema[]> {
    return newRequest({
        body: { url: URL_ATUAL },
        token: false,
        type: 'post',
        url: 'Sistema/Sistema',
    });
}

export const API_SISTEMA_POST_KEY = 'apiSistemaPost';

export function useSistemaQuery() {
    const { data, isFetching, error } = useQuery({
        queryFn: () => apiSistemaPost(),
        queryKey: [API_SISTEMA_POST_KEY, URL_ATUAL],
        staleTime: Infinity,
    });

    return {
        error,
        isFetching,
        sistema: data?.[0],
    };
}
